import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const HomePage = () => import('../views/HomePage')


const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: [{
      path: '/',
      component: HomePage,
    },{
      path: '/news-page',
      component: () =>import("../views/NewsPage.vue")
    },{
      path: '/about-us',
      component: () =>import("../views/AboutUs.vue")
    },{
      path: '/submenu-gw',
      component: () =>import("../views/subMenu/GWShow.vue")
    },{
      path: '/submenu-yy',
      component: () =>import("../views/subMenu/YYShow.vue")
    },{
      path: '/submenu-yybond',
      component: () =>import("../views/subMenu/YYBond.vue")
    },{
      path: '/submenu-basics',
      component: () =>import("../views/subMenu/Basics.vue")
    },{
      path: '/submenu-basicsin',
      component: () =>import("../views/subMenu/BasicsIn.vue")
    },{
      path: '/submenu-basicsout',
      component: () =>import("../views/subMenu/BasicsOut.vue")
    },{
      path: '/submenu-product',
      component: () =>import("../views/subMenu/Product.vue")
    },{
      path: '/submenu-schemedetails',
      component: () =>import("../views/subMenu/SchemeDetails.vue")
    }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js